import { CircleAlertIcon } from "lucide-react";
import classNames from "@/helpers/classNames";
import React from "react";

export const InputErrorIndicator = ({
  className,
  ...props
}: React.ComponentProps<"div">) => {
  return (
    <div
      className={classNames(
        "pointer-events-none flex shrink-0 items-center",
        className,
      )}
      {...props}
    >
      <CircleAlertIcon className="size-5 text-red-500" aria-hidden="true" />
    </div>
  );
};
